/* eslint-disable no-await-in-loop */
import React from 'react';
import ReactDOM from 'react-dom';
// base
import Loading from '../Loading';
import Collapse from '../Collapse';
import Icon from '../Icon';
import NCTable from '../Table';
import Checkbox from '../Checkbox';
import { TABLE_HEAD_CHECKBOX_CLASS_NAME } from './constants';
import { cloneDeep } from 'lodash';

import DndColumnConfig from './components/columnConfig';

import { getSysFieldid } from '@platform/api';
import {
    findParentTd,
    getGlobalStorage,
    pageTo,
    getSafeRandom,
    isFunction,
} from '@platform/api';

import { formatNumber, formatDatetime } from '../../api/getDataFormat';

// api
import BaseRefer from './BaseRefer';
const { Panel } = Collapse;
const Table = NCTable.sort(NCTable);
const defaultColor = ['#111111', '#555555', '#111', '#555'];
const tableRowHeight = 30;

class Refer extends BaseRefer {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            rowIndex: -1, //树表hover时表格各行的索引
            selectedRowIndex: 0, //选择表格行索引
            showColumnConfigPop: true, //控制列设置按钮显示、关闭
            columnConfigWidthDrop: {}, //列宽
            tableWidth: 0, //下拉参照弹出面板宽度
            columnLastData: {}, //拖拽列之前的列宽
            isAdjustCoulmnWidth: false,
            columnConfigInDrop: [...props.columnConfig], // 列设置
        };
        this.canload = true;
        this.interval = 0;
        if (props.clickContainer) {
            this.clickContainer = {
                ...props.clickContainer,
                props: {
                    ...props.clickContainer.props,
                    onClick: this.show,
                },
            };
            Object.defineProperty(this.clickContainer, 'props', {
                writable: false,
                configurable: false,
                value: this.clickContainer.props,
                enumerable: true,
            });
        }

    }

    componentWillUnmount() {
        super.componentWillUnmount();
        // this.columnConfigOrign = cloneDeep(this.props.columnConfig);

        delete this.referList;
    }
    componentDidMount() {
        super.componentDidMount();
        setTimeout(() => {
            this.columnConfigOrign = cloneDeep(this.props.columnConfig);
        }, 2000);
    }

    // 计算参照输入框位置
    calcFixed = (dom, container = this.props.container) => {
        if (dom && dom !== container) {
            var pos = dom.getBoundingClientRect(),
                top = pos.top,
                left = pos.left,
                referHeight = this.referContainer.offsetHeight,
                dropDownWidth =
                    this.referContainer.offsetWidth *
                    this.state.columnConfigInDrop.length;
            if (top + referHeight + 204 > document.body.clientHeight) {
                top = top - referHeight - 208 - 122;
            }
            if (left + dropDownWidth > document.body.clientWidth) {
                left = pos.right - dropDownWidth;
            }
            return {
                top,
                left,
            };
        } else {
            return {
                top: 0,
                left: 0,
            };
        }
    };

    // 查询下级分类
    getOptions = async (item, level) => {
        let { tableData, columnConfigInDrop } = this.state;
        let { isTreeCanSelect, pageSize, isCacheable, idKey } = this.props;
        if (Array.isArray(columnConfigInDrop) && columnConfigInDrop.length) {
            //点击的是分类
            if (columnConfigInDrop.length > level) {
                //如果没到最后一级分类，则查询下级分类
                // tableData.length = level + 1;
                if (isTreeCanSelect) {
                    this.singleSelect(item);
                }
                tableData[level - 1].selectedData = item;
                tableData[level] = tableData[level] || {
                    rows: [],
                    page: {
                        pageIndex: 0,
                        pageSize,
                    },
                };
                if (!(tableData[level].rows.length && isCacheable)) {
                    await this.loadTableData({
                        pid: item[idKey],
                        page: tableData[level].page,
                    }).then((data) => {
                        this.setTableData('tableData', level, data);
                    });
                }
                this.setState({
                    tableData,
                    currentLevel: level,
                });
            } else {
                //否则选中数据
                this.singleSelect(item);
            }
        } else {
            //点击的是数据列，选中数据
            this.singleSelect(item);
        }
    };

    // 加载下一页的请求
    getMoreOptions = (index) => {
        let { tableData } = this.state,
            { queryGrideUrl, idKey } = this.props;
        let pid = index ? tableData[index - 1].selectedData[idKey] : '';
        tableData[index].page.pageIndex++;
        let param = this.__getParam({
                pageInfo: tableData[index].page,
                pid,
            }),
            cacheData = this.hasCache(queryGrideUrl, param);
        // console.log('第', index + 1, '级菜单加载下一页，现在第', tableData[index].page.pageIndex, '页');
        if (cacheData) {
            this.setTableData('tableData', index, cacheData);
        } else {
            this.loadTableData(param).then((data) => {
                this.setTableData('tableData', index, data);
                this.canload = true;
            });
        }
    };

    //分页加载
    ulScroll = (level, e) => {
        let { tableData, isShow } = this.state;
        if (!isShow) {
            return;
        }
        if (
            e.target.scrollTop >
            e.target.firstChild.clientHeight - e.target.clientHeight - 5
        ) {
            if (
                tableData[level].page.pageIndex <
                tableData[level].page.totalPage - 1
            ) {
                this.canload && this.getMoreOptions(level);
                // 防止多次请求
                this.canload = false;
            }
        }
    };

    // 复写原型方法：点击参照三个点的事件
    show = () => {
        let { disabled, isCacheable, queryGridUrl } = this.props;
        let { columnConfigInDrop } = this.state;
        if (disabled) {
            return false;
        }
        let { tableData, currentLevel } = this.state,
            param,
            cacheData;
        currentLevel = 0;
        tableData[currentLevel].rows = [];

        //参照弹窗列设置缓存适当清除/添加
        let columnConfigWidth = this.getColumnConfigWidth();
        if (JSON.stringify(columnConfigWidth) !== '{}') {
            let othersColumnConfig = this.getDropReferColumns(true, true);

            if (
                Object.keys(columnConfigWidth).length - this.funColumnNum() >
                othersColumnConfig.length
            ) {
                let a = Object.keys(columnConfigWidth);
                let othersColumnKeys = [];
                othersColumnConfig.forEach((e) => {
                    othersColumnKeys.push(e.key);
                });

                a.forEach((e, i) => {
                    // console.log(e);
                    if (
                        !othersColumnKeys.includes(e) &&
                        e !== '__checkbox__' &&
                        e !== '__index__' &&
                        e !== '__opt__'
                    ) {
                        columnConfigWidth[e] = 0;
                        delete columnConfigWidth[e];
                    }
                });
                this.pushAdjustColumnConfigWidth(columnConfigWidth);
            } else if (
                Object.keys(columnConfigWidth).length - this.funColumnNum() <
                othersColumnConfig.length
            ) {
                //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
                for (let e of othersColumnConfig) {
                    if (!Object.keys(columnConfigWidth).includes(e.key)) {
                        columnConfigWidth[e.key] = 80;
                    }
                }
                this.pushAdjustColumnConfigWidth(columnConfigWidth);
            }
        }

        this.setState(
            {
                currentLevel,
                dropDownShow: false,
                isShow: true,
            },
            () => {
                if (!(tableData[currentLevel].rows.length && isCacheable)) {
                    if (
                        typeof columnConfigInDrop === 'object' &&
                        columnConfigInDrop.length > 1
                    ) {
                        // 多级菜单型
                        this.state.tableData[0].rows = [];
                        this.state.tableData.length = 1;
                        this.asyncLoad();
                    } else {
                        // 列表型
                        param = this.__getParam();
                        cacheData = this.hasCache(queryGridUrl, param);
                        if (cacheData) {
                            this.setTableData(
                                'tableData',
                                currentLevel,
                                cacheData
                            );
                        } else {
                            this.loadTableData(param).then((data) => {
                                this.state.tableData[0].rows = [];
                                this.setTableData(
                                    'tableData',
                                    currentLevel,
                                    data
                                );
                            });
                        }
                    }
                }
                this.referInput && this.referInput.focus();
            }
        );
    };

    // 根据columnConfig获取基本列信息
    getDropReferColumns = (selectedShow, DropDownSearchFlag) => {
        const { referVal } = this.props;
        let { columnConfigInDrop } = this.state;
        // let columnConfigInDrop =
        //     columnConfigInDrop.length === 0
        //         ? this.props.columnConfigInDrop
        //         : columnConfigInDrop;
        let {
            name: names,
            code: codes,
            checked = {},
            width = {},
            itemtype = {},
            contentcolor = {},
        } = columnConfigInDrop[0];
        let searchVal;

        //表头添加列设置

        // names.push('columnconfig');
        names = [...new Set(names)];
        codes = [...new Set(codes)];
        if (DropDownSearchFlag) {
            searchVal = referVal;
        }
        // if (treeConfig.name.length === 2) {
        //     treeConfig.name = [...names];
        //     treeConfig.code = [...codes];
        // }

        return names
            .map((e, i) => {
                return {
                    title: (
                        <span
                            className="refer-table-title"
                            fieldid={getSysFieldid(codes[i])}
                            title={e}
                            style={{
                                color: defaultColor.includes(
                                    contentcolor[codes[i]]
                                )
                                    ? ''
                                    : contentcolor[codes[i]],
                            }}
                        >
                            {e}
                        </span>
                    ),
                    label: e,
                    key: codes[i],
                    width: width[codes[i]] || '150px',
                    isSort: true,
                    filterable: true,
                    sorter: function (a, b) {
                        let key = codes[i];
                        let aValue =
                            a[key] ||
                            a?.values?.[key]?.value ||
                            a?.values?.[key]?.display ||
                            '';
                        let bValue =
                            b[key] ||
                            b?.values?.[key]?.value ||
                            b?.values?.[key]?.display ||
                            '';
                        return aValue >= bValue ? 1 : -1;
                    },
                    render: (text, row) => {
                        let label =
                            row[codes[i]] ||
                            (row.values &&
                                row.values[codes[i]] &&
                                (row.values[codes[i]].display ||
                                    row.values[codes[i]].value ||
                                    ''));

                        //在这进行数据的判断、转换
                        //在这解析出itemtype,形如width
                        let itemstyle = itemtype[codes[i]] || '';
                        switch (itemstyle) {
                            case 'datepicker':
                                label = formatDatetime(label, 'date');
                                break;
                            case 'datetimepicker':
                                label = formatDatetime(label, 'datetime');
                                break;
                            case 'timepicker':
                                label = formatDatetime(label, 'time');
                                break;
                            case 'number':
                                label = formatNumber(label);
                                break;
                            default:
                                break;
                        }
                        //   label =
                        //       itemstyle === 'datepicker'
                        //           ? formatDatetime(label, 'datetime')
                        //           : itemstyle === 'number'
                        //           ? formatNumber(label)
                        //           : label;

                        let highlightLabel =
                            label && searchVal && !selectedShow
                                ? this.renderTableLabelHighLight(
                                      label,
                                      codes[i],
                                      searchVal,
                                      false
                                  )
                                : label;
                        return (
                            <div
                                className="refer-td"
                                fieldid={getSysFieldid(codes[i])}
                                title={label}
                            >
                                {highlightLabel || <span>&nbsp;</span>}
                            </div>
                        );
                    },
                    __type__: 'commonColumn',
                };
            })
            .filter((e, i) => checked[codes[i]] !== false);
    };

    //渲染下拉参照的列设置
    renderDropColumnConfig = () => {
        let { showColumnConfigPop, jsonInsideRefer, columnConfigInDrop } =
            this.state;
        // { name: names, code: codes, checked = {} } = columnConfigInDrop[0],
        let { refType, type } = this.props;

        return (
            <DndColumnConfig
                columnConfig={columnConfigInDrop}
                showColumnConfigPop={showColumnConfigPop}
                refType={refType}
                type={type}
                jsonInsideRefer={jsonInsideRefer}
                // pushToColumnConfig={this.pushToColumnConfig}
                resetColumnConfig={this.resetColumnConfig}
                updateColumnConfig={(updateColumnConfig) => {
                    this.setState({ columnConfigInDrop: updateColumnConfig });
                }}
                updateColumnConfigPop={(columnConfigPopFlag) => {
                    this.setState({ showColumnConfigPop: columnConfigPopFlag });
                }}
            ></DndColumnConfig>
        );
    };

    // 右侧表格行点击
    onRowClick = (record, index, e) => {
        // 为了避免和新开发的行框选点选区域选事件冲突
        if (e.ctrlKey || e.shiftKey || e.metaKey) {
            return;
        }
        e.stopPropagation();

        let { selectedValues } = this.state;
        let { isMultiSelectedEnabled } = this.props;
        if (
            (!isMultiSelectedEnabled &&
                e.target.outerHTML ==
                    '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>') ||
            e.target.outerHTML ==
                '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>'
        ) {
            console.log('点击收藏跳过表格');
            return;
        } else if (
            isMultiSelectedEnabled &&
            (e.target.outerHTML ==
                '<span class="iconfont icon-shoucang" style="cursor: pointer;"></span>' ||
                e.target.outerHTML ==
                    '<span class="iconfont icon-shoucangdianliang" style="cursor: pointer;"></span>')
        ) {
            console.log('点击收藏跳过表格');
            return;
        }
        if (isMultiSelectedEnabled) {
            // 多选--待定，之前这里是多选模式
            // selectedValues = new Map([[record.refpk, record]]);
            selectedValues.set(record.refpk, record);
            let referVal = this.showCodeIfPossible([
                ...selectedValues.values(),
            ]);
            // this.multiSelect();
            this.setState({
                // showHistoryFlag: true,
                referVal,
            });
            // this.handleShowHistory(true); //解决选完一个值之后，历史记录页签切换问题

            // this.handleMultiSelect();
            // this.handleReferVal(referVal);
        } else {
            // 单选
            selectedValues = new Map(
                Object.entries({ [record.refpk]: record })
            );
            let referVal = this.showCodeIfPossible([
                ...selectedValues.values(),
            ]);

            this.singleSelect(record);
            this.setState({
                // showHistoryFlag: true,
                // referVal,
                showDropDownTable: false,
            });

            // this.handleShowHistory(true);
            // this.handleSingleSelect(record);
            // this.handleReferVal(referVal);

            // this.props.handleHideDropTable(); //弹窗，收起下拉面板
            // this.props.handleOnlyHideDropTable();
        }
        this.setState({ selectedRowIndex: index });
        // this.handleSelectedValues(selectedValues);
    };

    // 表格行双击
    onRowDoubleClick = (record, index, e) => {
        e.stopPropagation();
        let { selectedValues } = this.state;
        let { isMultiSelectedEnabled } = this.props;

        if (isMultiSelectedEnabled) {
            // 多选
            selectedValues.set(record.refpk, record);

            let referVal = this.showCodeIfPossible([
                ...selectedValues.values(),
            ]);
            // this.handleSelectedValues(selectedValues);
            // this.handleMultiSelect();
            // this.handleReferVal(referVal);
            // // this.props.handleHideDropTable(); //弹窗，收起下拉面板
            // this.props.handleOnlyHideDropTable();

            this.multiSelect();
            this.setState({
                selectedValues,
                referVal,
                showDropDownTable: false,
            });
        } else {
            // 单选
            selectedValues = new Map(
                Object.entries({
                    [record.refpk]: record,
                })
            );
            // selectedValues.clear();

            let referVal = this.showCodeIfPossible([record]);
            // this.handleSingleSelect(record);
            // this.handleReferVal(referVal);
            // // this.handleSelectedValues(selectedValues);
            // this.props.handleOnlyHideDropTable();

            this.singleSelect(record);
            this.setState({
                // referVal,
                showDropDownTable: false,
            });
        }
        // this.handlePopoverBlur();
        // this.props.handleHideDropTable(); //弹窗，收起下拉面板
    };

    // 表格行的className
    rowClassName = (record, index) => {
        let { selectedRowIndex, rowIndex, selectedValues } = this.state,
            className = '';
        if (selectedValues.get(record.refpk)) {
            className = 'refer-selected-row';
        }
        if (selectedRowIndex === index) {
            className += ' refer-focus-row';
        }
        if (rowIndex === index) {
            className += ' refer-hover-row';
        }
        if (rowIndex === index && selectedValues.get(record.refpk)) {
            className += ' refer-hover-select-row';
        }
        return className.trim();
    };

    // 检查是否是全选
    isAllChecked = () => {
        let { selectedValues, tableData } = this.state;

        let data = tableData[0].rows || [];
        return !!(
            selectedValues.size &&
            data.length &&
            data.every((e) => !e._disabled && selectedValues.has(e.refpk))
        );
    };

    // 检查是否 中间态
    isIndeterminated = () => {
        let { selectedValues, tableData } = this.state;

        let data = tableData[0].rows || [];
        return (
            selectedValues.size > 0 &&
            data.length &&
            !this.isAllChecked() &&
            data.find((e) => selectedValues.has(e.refpk))
        );
    };

    // 表格部分的全选
    checkAll = (val) => {
        let { tableData, selectedValues } = this.state;

        let data = tableData[0].rows || [];

        if (val) {
            data.forEach((e) => {
                selectedValues.set(e.refpk, e);
            });
        } else {
            data.forEach((e) => {
                selectedValues.delete(e.refpk);
            });
        }
        let referVal = this.showCodeIfPossible([...selectedValues.values()]);

        this.setState({
            selectedValues,
            referVal,
            // showHistoryFlag: true,
        });

        // this.setState({ selectedValues });
    };

    // 从localStorage中取下拉面板列宽度设置
    getColumnConfigWidth = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidthDrop') ||
                    '{}'
            )[configKey] || {}
        );
    };

    // 存入列设置
    pushToColumnConfig = () => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            { columnConfigInDrop: config } = this.state,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfig = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            );

        ColumnConfig[configKey] = config;
        this.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
    };

    // 存入列宽度设置
    pushToColumnConfigWidth = () => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            { columnConfigWidthDrop: config } = this.state,
            configKey = queryGridUrl + queryTreeUrl + userId,
            columnConfigWidthDrop = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidthDrop') ||
                    '{}'
            );

        columnConfigWidthDrop[configKey] = config;
        this.setStorage(
            'ColumnConfigWidthDrop',
            JSON.stringify(columnConfigWidthDrop)
        );
    };

    // render中存入列宽度设置
    pushAdjustColumnConfigWidth = (config) => {
        // [{name: ['编码', '名称'], code: ['refcode', 'refname']}]
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            columnConfigWidthDrop = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidthDrop') ||
                    '{}'
            );

        columnConfigWidthDrop[configKey] = config;
        this.setStorage(
            'ColumnConfigWidthDrop',
            JSON.stringify(columnConfigWidthDrop)
        );
    };

    //调整下拉面板各列的宽度
    onDropBorderHandler = (dropWidth, column, columnsConfig) => {
        let { columnConfigWidthDrop } = this.state;

        //若拖拽完列之后，若所有列的宽度之和小于下拉面板的极大值，更新下拉面板宽度，即极大值范围内随着列的拖动，下拉面板宽度缩短
        columnsConfig.forEach((e) => (columnConfigWidthDrop[e.key] = e.width));
        if (dropWidth < column.width) {
            let oldDropData = {};
            oldDropData[column.key] = column.width;

            this.setState({ columnLastData: oldDropData });
            this.isChangeColumnData = true;
        } else if (dropWidth > column.width) {
            let oldDropData = {};

            this.setState({ columnLastData: oldDropData });
        }
        columnConfigWidthDrop[column.key] = dropWidth;

        //列设置宽度记忆
        this.pushToColumnConfigWidth();

        //关闭列设置面板
        // this.showColumnConfigPopDrop();

        this.setState({
            columnConfigWidthDrop,
            isAdjustCoulmnWidth: true,
            showColumnConfigPop: false,
        });

        let timer = setTimeout(() => {
            this.referInput && this.referInput.focus();
            clearTimeout(timer);
        }, 10);
    };

    // 从localStorage中取列设置
    getColumnConfig = (props) => {
        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { columnConfig, queryGridUrl, queryTreeUrl } = props || this.props,
            configKey = queryGridUrl + queryTreeUrl + userId;
        return (
            JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            )[configKey] || JSON.parse(JSON.stringify(columnConfig))
        );
    };

    // 重置下拉面板列宽度设置
    resetColumnConfigWidth = () => {
        //若有滚动条，把滚动条置为0后在localStorage中存值

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfigWidthDrop = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfigWidthDrop') ||
                    '{}'
            );
        delete ColumnConfigWidthDrop[configKey];
        this.setStorage(
            'ColumnConfigWidthDrop',
            JSON.stringify(ColumnConfigWidthDrop)
        );
        this.setState({ ColumnConfigWidthDrop: {} });
    };

    // 重置下拉参照弹出表格的列设置
    resetColumnConfig = () => {
        //点击历史记录时，重置下拉表格的列设置面板

        this.resetColumnConfigWidth();

        this.setState({
            showColumnConfigPop: false,
            columnConfigInDrop: cloneDeep(this.columnConfigOrign),
        });

        let userData = JSON.parse(
            getGlobalStorage('localStorage', 'STOREFORINFODATA')
        );
        let userId = (userData && userData.userId) || '';
        let { queryGridUrl, queryTreeUrl } = this.props,
            configKey = queryGridUrl + queryTreeUrl + userId,
            ColumnConfig = JSON.parse(
                getGlobalStorage('localStorage', 'ColumnConfig') || '{}'
            );
        delete ColumnConfig[configKey];
        this.setStorage('ColumnConfig', JSON.stringify(ColumnConfig));
        // this.setState({ columnConfigInDrop: this.getColumnConfig() });
    };

    // 复写原型方法：下拉
    renderDropDown = () => {
        let {
            tableData,
            currentLevel,
            selectedValues,
            isShow,
            loading,
            fieldValued,
            columnConfigWidthDrop,
            tableWidth,
            isAdjustCoulmnWidth,
            columnLastData,
            columnConfigInDrop,
            type,
            jsonInsideRefer,
        } = this.state;
        let {
            ellipsis,
            container,
            idKey,
            attrcode,
            fieldid,
            isMultiSelectedEnabled,
            showClassification,
            refType,
        } = this.props;
        // let multiMenuWidth = columnConfigInDrop.length ? (currentLevel + 1) * fixWidth + currentLevel * 4 : '100%';

        let fixWidth =
            (this.referContainer && this.referContainer.offsetWidth) || 0;
        let multiMenuWidth = columnConfigInDrop.length
            ? columnConfigInDrop.length * fixWidth +
              (columnConfigInDrop.length - 1) * 4
            : fixWidth;
        let fieldidValue = null;
        let columns = [];

        isMultiSelectedEnabled &&
            columns.unshift({
                isSort: false,
                title: (
                    <label className="refer-table-label">
                        <span
                            className="checkbox-column"
                            fieldid={getSysFieldid('firstcol')}
                        >
                            <Checkbox
                                onChange={this.checkAll}
                                checked={this.isAllChecked()}
                                tabIndex={40}
                                // 增加一个中间态
                                indeterminate={this.isIndeterminated()}
                                className={TABLE_HEAD_CHECKBOX_CLASS_NAME}
                                // onKeyDown={this.handleTableHeadCheckboxKeyDown}
                                // onKeyUp={this.preventDefaultTableCheckbox}
                            />
                        </span>
                    </label>
                ), // 全选效果
                key: '__checkbox__',
                width: columnConfigWidthDrop['__checkbox__'] || 32,
                // width: 32,

                fixed: 'left',
                render: (text, row, index) => {
                    return (
                        <label className="refer-table-label">
                            <span
                                fieldid={getSysFieldid('firstcol')}
                                onClickCapture={(e) => {
                                    if (e.ctrlKey || e.shiftKey || e.metaKey) {
                                        e.stopPropagation();
                                    }
                                }}
                            >
                                <Checkbox
                                    onClick={(e) => {
                                        let { selectedValues } = this.state;
                                        e.stopPropagation();
                                        this.toggleValueForMapOrObject(
                                            selectedValues,
                                            row.refpk,
                                            row
                                        );
                                        // isMultiSelectMode ||
                                        //     this.onRowClick(row, index, e);
                                        let referVal = this.showCodeIfPossible([
                                            ...selectedValues.values(),
                                        ]);
                                        this.setState({
                                            referVal: referVal,
                                            selectedValues,
                                            // showHistoryFlag: true,
                                        });
                                        // this.handleReferVal(referVal);
                                        // this.handleSelectedValues(
                                        //     selectedValues
                                        // );
                                        // this.handleShowHistory(true);
                                    }}
                                    checked={
                                        this.state.selectedValues.size !== 0
                                            ? !!(
                                                  this.state.selectedValues.get(
                                                      row[fieldValued]
                                                  ) ||
                                                  this.state.selectedValues.get(
                                                      row.refpk
                                                  )
                                              )
                                            : false
                                    }
                                    tabIndex="-1"
                                    disabled={row._disabled}
                                />
                            </span>
                        </label>
                    );
                },
            });
        let othersColumnConfig = this.getDropReferColumns(true, true);

        //计算下拉参照弹出面板的宽度
        columnConfigWidthDrop = this.getColumnConfigWidth();
        this.deleteColumnFlag = false;
        this.addColumnFlag = false;

        if (JSON.stringify(columnConfigWidthDrop) !== '{}') {
            //过滤check,删除掉check等于false的列信息
            othersColumnConfig.forEach(
                (e) => (e.width = columnConfigWidthDrop[e.key])
            ); //下拉面板各列的宽度，自己维护

            //在列设置数据添加/删除时，更新各列宽度数据缓存，
            //注意，是计算完下拉面板宽度后去更新所有列宽，以维持当前下拉面板宽度不实时变化
            if (!isAdjustCoulmnWidth) {
                if (
                    Object.keys(columnConfigWidthDrop).length -
                        this.funColumnNum() >
                    othersColumnConfig.length
                ) {
                    tableWidth = 0;
                    Object.values(columnConfigWidthDrop).forEach(
                        (e) => (tableWidth += e)
                    );
                    tableWidth += 8; //加滚动条的宽度
                    // tableWidth += 40; //加悬浮列的宽度
                    this.pushAdjustColumnConfigWidth(columnConfigWidthDrop);

                    this.deleteColumnFlag = true;
                } else if (
                    Object.keys(columnConfigWidthDrop).length -
                        this.funColumnNum() <
                    othersColumnConfig.length
                ) {
                    tableWidth = 0;

                    Object.values(columnConfigWidthDrop).forEach(
                        (e) => (tableWidth += e)
                    );
                    tableWidth += 8; //加滚动条的宽度
                    // tableWidth += 40; //加悬浮列的宽度

                    this.pushAdjustColumnConfigWidth(columnConfigWidthDrop);

                    //在columnConfigWidth找出来othersColumnConfig中没有的值，置为80
                    for (let e of othersColumnConfig) {
                        if (
                            !Object.keys(columnConfigWidthDrop).includes(e.key)
                        ) {
                            e.width = 80;
                        }
                    }

                    this.addColumnFlag = true;
                }
            }

            //处理列调整时最后一列的宽度

            if (
                othersColumnConfig[othersColumnConfig.length - 1].key !==
                this.lastColumnKey
            ) {
                this.count = 0;
                //把上一个加过40的列宽恢复
                if (this.lastColumnKey) {
                    othersColumnConfig.forEach((e) => {
                        if (e.key === this.lastColumnKey) {
                            // e.width -= 40;
                        }
                    });
                }
            }
            if (this.count === 0) {
                this.backWidth =
                    othersColumnConfig[othersColumnConfig.length - 1].width;
            }

            // othersColumnConfig[lastColumnKeyIndex].width = backWidth;
            // othersColumnConfig[othersColumnConfig.length - 1].width =
            //     beforeWidth;

            //为避免问题，先来个原有得复制

            if (!this.deleteColumnFlag && !this.addColumnFlag) {
                tableWidth = 0;
                othersColumnConfig.forEach((e) => (tableWidth += e.width));
                columns.forEach((e) => (tableWidth += e.width));
                tableWidth += 8; //加滚动条的宽度
                tableWidth += 40; //加悬浮列的宽度
            }

            //504是ue设置的最大宽度，40是列设置的默认宽度，60是除列设置外最后一列的宽度
            //按道理，该判断逻辑只执行一次
            if (
                tableWidth > 504 &&
                othersColumnConfig[othersColumnConfig.length - 1].width ===
                    this.backWidth
            ) {
                tableWidth = 504;

                othersColumnConfig[othersColumnConfig.length - 1].width =
                    this.backWidth + 40;
                this.count += 1;
            } else if (
                //该逻辑的执行场景为展示面板后调整了列宽度且使总的列宽大于了面板宽度极值
                //此时，若调整某列宽度，致使总列宽小于下拉面板宽度极值，执行以下逻辑
                //以下相当于重新设置各列宽度，计算下拉面板宽度
                othersColumnConfig[othersColumnConfig.length - 1].width ===
                    this.backWidth + 40 &&
                tableWidth <= 544 &&
                this.count > 0
            ) {
                othersColumnConfig[othersColumnConfig.length - 1].width =
                    this.backWidth;
                tableWidth -= 32; //去除滚动条宽度

                //如果宽度过小，咋办
                if (tableWidth < 504) {
                    tableWidth = 0;
                    othersColumnConfig.forEach((e) => (tableWidth += e.width));
                    columns.forEach((e) => (tableWidth += e.width));
                    tableWidth += 8; //加滚动条的宽度
                    tableWidth += 40; //加悬浮列的宽度

                    //若缩小时，横向滑动条在下拉面板的最右侧，滚动条距离右侧的距离设置为0，此时方能使滚动条消失
                    if (this.referList && this.referList.scrollLeft > 0) {
                        this.referList.scrollLeft = 0;
                    }
                }
            }

            //若列宽度拖小，每拖小一次，执行一次以下逻辑
            if (
                JSON.stringify(columnLastData) !== '{}' &&
                this.isChangeColumnData
            ) {
                console.log(Object.keys(columnLastData));
                this.isChangeColumnData = false;
                let adjustIndex = othersColumnConfig.findIndex(
                    (e) => e.key === Object.keys(columnLastData)[0]
                );

                //如果缩小某一列宽之后的下拉面板的宽度仍大于504，使下拉面板宽度等于极大值且横向滚动条左移对应拖拽缩小宽度
                if (
                    tableWidth > 504 &&
                    this.backWidth <
                        othersColumnConfig[othersColumnConfig.length - 1]
                            .width <=
                        this.backWidth + 40 &&
                    othersColumnConfig[adjustIndex] &&
                    othersColumnConfig[adjustIndex].width <
                        Object.values(columnLastData)[0]
                ) {
                    let diff =
                        Object.values(columnLastData)[0] -
                        othersColumnConfig[adjustIndex].width;
                    // othersColumnConfig[othersColumnConfig.length - 1].width -=
                    //     diff;
                    tableWidth = 504;
                    // tableWidth -= diff;
                    if (this.referList && this.referList.scrollLeft > 0) {
                        this.referList.scrollLeft -= diff;
                    }
                }
            }

            if (tableWidth > 504) {
                tableWidth = 504;
            }
        } else {
            tableWidth = 0;
            othersColumnConfig.forEach((e, index) => {
                if (showClassification && type !== 'dropDown') {
                    if (index === 0) {
                        e.width = 100;
                    } else if (index === 1) {
                        e.width = 150;
                    } else {
                        e.width = 80;
                    }
                } else {
                    if (index === 0) {
                        e.width = 150;
                    } else if (index === 1) {
                        e.width = 100;
                    } else {
                        e.width = 80;
                    }
                }
            }); //下拉面板各列的宽度，设置默认值
            othersColumnConfig.forEach((e) => (tableWidth += e.width));
            columns.forEach((e) => (tableWidth += e.width));
            tableWidth += 8; //加滚动条的宽度
            tableWidth += 40; //加悬浮列的宽度

            //表参照与树参照只有两列时，是不是第一次渲染的时候执行就行，若coulmnConfigWidth有值了，按照对应值渲染即可
            //不能仅第一次渲染配置columnConfig,若后期调整分辨率，参照宽度变了，咋办
            if (
                refType !== 'gridTree' &&
                othersColumnConfig.length === 2 &&
                isAdjustCoulmnWidth === false
            ) {
                if (fixWidth < 232) {
                    fixWidth = 232;
                }
                tableWidth = fixWidth;
                let averageWidth;
                if (isMultiSelectedEnabled) {
                    othersColumnConfig.forEach((e, index) => {
                        averageWidth = (fixWidth - 45 - 40) / 2;
                        e.width = averageWidth;
                        if (index === 0) {
                            e.width = 150;
                        }
                    }); //下拉面板各列的宽度，设置默认值
                } else {
                    othersColumnConfig.forEach((e, index) => {
                        averageWidth = (fixWidth - 40) / 2;
                        e.width = averageWidth;
                        if (index === 0) {
                            e.width = 150;
                        }
                    }); //下拉面板各列的宽度，设置默认值
                }
                tableWidth += 150 - averageWidth; //编码字段默认显示150
                // tableWidth -= 8;
            }

            //下拉参照只有一列时，是不是第一次渲染的时候执行就行，若coulmnConfigWidth有值了，按照对应值渲染即可
            if (
                refType !== 'gridTree' &&
                othersColumnConfig.length === 1 &&
                isAdjustCoulmnWidth === false
            ) {
                if (fixWidth < 232) {
                    fixWidth = 232;
                }
                tableWidth = fixWidth;
                if (isMultiSelectedEnabled) {
                    othersColumnConfig.forEach((e, index) => {
                        let averageWidth = fixWidth - 45; //下拉参照先不加列设置，故减去40
                        e.width = averageWidth;
                    }); //下拉面板各列的宽度，设置默认值
                } else {
                    othersColumnConfig.forEach((e, index) => {
                        let averageWidth = fixWidth; //下拉参照先不加列设置，故减去40
                        e.width = averageWidth - 40 - 8;
                    }); //下拉面板各列的宽度，设置默认值
                }
                // tableWidth -= 8;
            }
        }

        //取最后一列数据的key，以备置顶、置底调整列设置
        this.lastColumnKey =
            othersColumnConfig[othersColumnConfig.length - 1].key;

        columns.push(...othersColumnConfig);

        //记得与funColumnNum()方法相关
        columns.push({
            // 操作
            title: (
                <span
                    fieldid={getSysFieldid('opr')}
                    onClick={() => {
                        this.setState({ isAdjustCoulmnWidth: false });
                    }}
                >
                    {this.renderDropColumnConfig()}
                </span>
            ), // 全选效果
            key: '__opt__',
            width: columnConfigWidthDrop['__opt__'] || 40,
            // width: 40,

            fixed: 'right',
            render: (text, row, index) => {
                return;
            },
        });

        //调整完面板后把列宽数据存储在localStorage中
        if (!this.deleteColumnFlag && !this.addColumnFlag) {
            let newColumnConfigWidth = {};
            columns.forEach((e) => (newColumnConfigWidth[e.key] = e.width));
            this.pushAdjustColumnConfigWidth(newColumnConfigWidth);
        }

        if (fieldid || attrcode) {
            fieldidValue = `${fieldid || attrcode}_refer`;
        }
        fieldidValue = getSysFieldid(fieldidValue);
        return ReactDOM.createPortal(
            <div
                fieldid={fieldidValue}
                className="refer-container dropdown-refer"
                onMouseDown={(e) => {
                    e.preventDefault();
                }}
            >
                <Loading container={this.referList} show={false} />
                <Panel
                    expanded={isShow}
                    className="dropdown-refer-collapse"
                    bodyClassName="dropdown-refer-collapse-body"
                    style={{
                        // overflow: 'hidden',
                        // width: multiMenuWidth,
                        // width: '504px',
                        maxWidth: '504px',
                        top:
                            this.calcFixed(this.referContainer).top +
                            (this.referContainer
                                ? this.referContainer.offsetHeight
                                : 0) +
                            4,
                        left: this.calcFixed(this.referContainer).left,
                        position: 'fixed',
                        zIndex: 301,
                    }}
                >
                    <div className="drop-table-title">
                        {jsonInsideRefer['containers-refer-0015']}
                    </div>
                    <div
                        ref={(dom) => {
                            this.referList = dom;
                        }}
                        className="refer-cascading-list clearfix"
                        style={{
                            maxWidth:
                                tableWidth > 504
                                    ? '504px'
                                    : tableWidth != 0 && tableWidth + 'px',
                            maxHeight: '286px',
                        }}
                    >
                        {/* <div
                            style={{
                                width: '100%',
                                height: '100%',
                                overflowX: 'hidden',
                            }}
                        >
                            <div
                                style={{
                                    width: multiMenuWidth,
                                    backgroundColor: '#eee',
                                    // overflowY: 'hidden',
                                }}
                            >
                                {tableData.map((list, level) => {
                                    if (currentLevel >= level) {
                                        return (
                                            <div
                                                className="scroll-div"
                                                key={level}
                                                style={{
                                                    width:
                                                        (multiMenuWidth -
                                                            currentLevel * 4) /
                                                        columnConfigInDrop.length,
                                                }}
                                            >
                                                <p
                                                    className="list-title"
                                                    style={{
                                                        height:
                                                            columnConfigInDrop[level]
                                                                .name[0] === ''
                                                                ? '0px'
                                                                : '24px',
                                                    }}
                                                >
                                                    {columnConfigInDrop[
                                                        level
                                                    ].name.join('/')}
                                                </p>
                                                <div
                                                    className="refer-scroll"
                                                    onScroll={(e) => {
                                                        this.ulScroll(level, e);
                                                    }}
                                                >
                                                    <ul
                                                        className="refer-cascading-item"
                                                        key={level}
                                                        style={{
                                                            width: columnConfigInDrop.length
                                                                ? 'auto'
                                                                : '100%',
                                                        }}
                                                    >
                                                        {list.rows.map(
                                                            (item, i) => {
                                                                let label =
                                                                    columnConfigInDrop[
                                                                        level
                                                                    ].code
                                                                        .map(
                                                                            (
                                                                                e
                                                                            ) => {
                                                                                return (
                                                                                    item[
                                                                                        e
                                                                                    ] ||
                                                                                    item
                                                                                        .values?.[
                                                                                        e
                                                                                    ]
                                                                                        ?.value
                                                                                );
                                                                            }
                                                                        )
                                                                        .join(
                                                                            '/'
                                                                        );
                                                                return (
                                                                    <li
                                                                        title={
                                                                            label
                                                                        }
                                                                        className={
                                                                            'clearfix refer-li' +
                                                                            (selectedValues.has(
                                                                                item[
                                                                                    idKey
                                                                                ]
                                                                            )
                                                                                ? ' selected'
                                                                                : '') +
                                                                            (list.selectedData &&
                                                                            list
                                                                                .selectedData[
                                                                                idKey
                                                                            ] ===
                                                                                item[
                                                                                    idKey
                                                                                ]
                                                                                ? ' active'
                                                                                : '')
                                                                        }
                                                                        key={i}
                                                                        onClick={this.getOptions.bind(
                                                                            this,
                                                                            item,
                                                                            Number(
                                                                                level
                                                                            ) +
                                                                                1
                                                                        )}
                                                                    >
                                                                        {ellipsis &&
                                                                        level >
                                                                            0 &&
                                                                        level ===
                                                                            columnConfigInDrop.length -
                                                                                1
                                                                            ? label.replace(
                                                                                  tableData[
                                                                                      level -
                                                                                          1
                                                                                  ]
                                                                                      .selectedData
                                                                                      .refname,
                                                                                  '...'
                                                                              )
                                                                            : label}
                                                                        {level <
                                                                            columnConfigInDrop.length -
                                                                                1 && (
                                                                            <Icon
                                                                                type="uf-anglearrowpointingtoright"
                                                                                style={{
                                                                                    position:
                                                                                        'absolute',
                                                                                    right: '-4px',
                                                                                    top: '50%',
                                                                                    marginTop:
                                                                                        ' -9px',
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </li>
                                                                );
                                                            }
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                        </div> */}
                        <Table
                            height={tableRowHeight}
                            headerHeight={tableRowHeight}
                            onRowClick={this.onRowClick}
                            onRowDoubleClick={this.onRowDoubleClick}
                            rowKey={'total-row'} //不是这个不更新columns,即bodyColumn
                            columns={[...columns]}
                            data={tableData[0].rows}
                            lazyload={false}
                            scroll={{
                                // 补正1px 避免表格横向滚动条被遮住1px
                                y: this.referTable?.clientHeight - 30 - 1,
                                x: true,
                            }}
                            rowClassName={this.rowClassName}
                            // 补正1px 避免表格横向滚动条被遮住1px
                            // bodyStyle={{
                            //     height: this.referTable?.clientHeight - 30 - 1,
                            // }}
                            focusable
                            // tabIndex={this.getTabIndex(
                            //     this.hotKeyElement.referTable
                            // )}
                            // onKeyDown={this.resetHotKeyLoop.bind(this, this.hotKeyElement.referTable)}
                            className={`refer-base-table dropdown-table ${'right-table-boxshadow'}`}
                            bodyClassName="refer-base-table-scroll-body"
                            ref={(dom) => {
                                this.droptable =
                                    ReactDOM.findDOMNode(dom)?.querySelector(
                                        `.dropdown-table`
                                    );
                            }}
                            // scrollTop={scrollTop}
                            addBlankCol={false}
                            // customSort={sort}
                            // {...emptyText}
                            emptyClassName="refer-select-empty"
                            columnWidthConfig={false}
                            onDropBorderHandler={(dropWidth, column) => {
                                this.onDropBorderHandler(
                                    dropWidth,
                                    column,
                                    columns
                                );
                            }}
                            sort={{ sortFun: this.handleSort }}
                            onRowHover={(index) => {
                                if (this.state.selectedRowIndex === 0) {
                                    this.setState({ selectedRowIndex: -1 });
                                }
                                this.setState({ rowIndex: index });
                            }}
                            onBodyScroll={() => {
                                console.log('表格在滚动');
                            }}
                        ></Table>
                    </div>
                </Panel>
            </div>,
            container,
        );
    };

    // 第一次查询的时候把多列的每一列数据都查出来
    asyncLoad = async function () {
        let { queryGrideUrl } = this.props,
            { tableData, columnConfigInDrop } = this.state,
            param = this.__getParam(),
            cacheData = this.hasCache(queryGrideUrl, param);
        if (cacheData) {
            this.setTableData('tableData', 0, cacheData);
        } else {
            await this.loadTableData(param).then((data) => {
                this.setTableData('tableData', 0, data);
            });
        }
        let length = columnConfigInDrop.length;
        for (let i = 1; i < length; i++) {
            if (tableData[i - 1].rows[0]) {
                tableData[i - 1].selectedData = tableData[i - 1].rows[0];
                await this.getOptions(tableData[i - 1].rows[0], i);
            }
        }
    };
}

export default Refer;
